module.exports = __webpack_public_path__ + "img/section1-2ListLeft.8b36cc2d.svg";